import { memo } from "react";
import {
  ComplainStatusColor,
  findObjectKeyByValue,
} from "../../utils/helpers/main";
import { Chip } from "@mui/material";
import { COMPLAIN_STATUS } from "../../utils/constants/main";

const ComplainStatusComponent = memo(({ params, setParams, onlyview }) => {
  return (
    <Chip
      size="small"
      color={ComplainStatusColor(params.status)}
      label={findObjectKeyByValue(params.status, COMPLAIN_STATUS)}
    />
  );
});
export default ComplainStatusComponent;
